export default "__VITE_ASSET__BfyJBihR__"